import { render, staticRenderFns } from "./approvedProductRetailerMarginList.vue?vue&type=template&id=caac76b0"
import script from "./approvedProductRetailerMarginList.vue?vue&type=script&lang=js"
export * from "./approvedProductRetailerMarginList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports